import React from 'react';
import { ISearchInput } from 'src/pages/CatalogPage/CatalogPage.i';
import { ClearFilters } from 'src/pages/CatalogPage/components/FilterMenu/ClearFilters/ClearFilters';
import { ISessionMapping } from 'src/pages/CatalogPage/Catalog.i';

import { Typography } from '@riac/design-system';

interface IFiltersSetDialog {
  searchInput: ISearchInput;
  searchName: string;
  sessions: ISessionMapping[];
  searchBusy: boolean;
}

export const getAppliedFilters = (searchInput:ISearchInput, sessions:ISessionMapping[]) => {
  const { keywords, amcode, hlo, manu, caliber, subcaliber, session } = searchInput;

  const appliedFilters = [];
  if(hlo.length > 0) {
    const HLOs = {
      H: 'Handgun',
      L: 'Long Gun',
      O: 'Other',
    };
    const HLO = hlo.length === 1 ? HLOs[hlo] : hlo;
    appliedFilters.push(HLO);
  }
  if(manu.length > 0) {
    appliedFilters.push(manu);
  }
  if(caliber.length > 0) {
    appliedFilters.push(caliber);
  }
  if(subcaliber.length > 0) {
    appliedFilters.push(subcaliber);
  }
  if(session.length > 0) {
    const sess = sessions.filter((s) => s.value == session)[0];
    const formattedDay = sess ? sess.name : '';
    appliedFilters.push(formattedDay);
  }
  if(amcode.length > 0) {
    const catFilters = {
      A: 'Antique Firearms',
      AL: 'Antique Lots',
      C: 'Curio & Relic',
      I: 'Class III',
      M: 'Modern Firearms',
    };
    appliedFilters.push(catFilters[amcode]);
  }

  return appliedFilters;
};

export const FiltersSetDialog = (props: IFiltersSetDialog) => {
  const { keywords } = props.searchInput;
  const appliedFilters = getAppliedFilters(props.searchInput, props.sessions);
  if(!props.searchName && !(appliedFilters.length > 0) && !(keywords.length > 0)) {
    return null;
  }
  return (
    <div className='flex flex-col gap-2 items-start'>
      {keywords.length > 0 && ( props.searchBusy ? <div>Searching for: {keywords}...</div> : <div>Searched for: {keywords}</div>)}
      {(appliedFilters.length > 0 || props.searchName) && <div className='flex flex-col gap-2'>
        <Typography weight='semibold' color='text' className='text-base leading-[22px]'>Applied:</Typography>
        <ul className='flex flex-col flex-wrap gap-2'>
          {appliedFilters.map((filter, i) => (
            <Typography tag='li' weight='semibold' key={i} color='text' size='xs'>
              + {filter}
            </Typography>
          ))}
          {props.searchName && <Typography tag='li' size='md' weight='medium' color='text' className={'ml-4 list-item'}>
            {props.searchName}
          </Typography>}
        </ul>
      </div>}
      <ClearFilters searchInput={props.searchInput} />
    </div>
  );
};
